/* eslint-disable @typescript-eslint/naming-convention */
import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import { msg } from '@lit/localize';
import type { LoyaltySystemConfig } from './types';

export const LOYALTY_SYSTEM_CONFIG: DiToken<LoyaltySystemConfig> = new DiToken<LoyaltySystemConfig>(
  'LOYALTY_SYSTEM_CONFIG',
  {
    factory: () => ({
      pointsName: msg('Loyalty Points'),
      freeSpinsName: msg('Free Spins'),
      cashbackTerms: msg(
        'Use your accumulated points in loyalty shop to claim exciting rewards like cashbacks, free spins, and other exclusive prizes. Real money bets only. T&C apply.'
      ),
      shopName: msg('Loyalty Shop')
    })
  }
);
